import { render, staticRenderFns } from "./generacionArchivoRenovacion.vue?vue&type=template&id=10640230"
import script from "./generacionArchivoRenovacion.vue?vue&type=script&lang=js"
export * from "./generacionArchivoRenovacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports